var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 7.1665C29.1325 7.1665 17.9166 18.3823 17.9166 32.2498C17.9166 38.4848 19.7083 44.3257 22.9691 49.5932C26.3733 55.1115 30.8525 59.8415 34.2925 65.3598C35.9766 68.0473 37.195 70.5557 38.485 73.4582C39.4166 75.429 40.1691 78.8332 43 78.8332C45.8308 78.8332 46.5833 75.429 47.4791 73.4582C48.805 70.5557 49.9875 68.0473 51.6716 65.3598C55.1116 59.8773 59.5908 55.1473 62.995 49.5932C66.2916 44.3257 68.0833 38.4848 68.0833 32.2498C68.0833 18.3823 56.8675 7.1665 43 7.1665ZM43 42.104C40.6241 42.104 38.3455 41.1602 36.6655 39.4802C34.9855 37.8002 34.0416 35.5216 34.0416 33.1457C34.0416 30.7698 34.9855 28.4912 36.6655 26.8112C38.3455 25.1312 40.6241 24.1873 43 24.1873C45.3759 24.1873 47.6545 25.1312 49.3345 26.8112C51.0145 28.4912 51.9583 30.7698 51.9583 33.1457C51.9583 35.5216 51.0145 37.8002 49.3345 39.4802C47.6545 41.1602 45.3759 42.104 43 42.104Z",
    fill: "#EA7575"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/MapMarker.4dbc14a617363f6c32dee8c39a46befa.svg";
export { ForwardRef as ReactComponent };